import { Language } from '@configs/language';

const BASE_LABELS = {
  addMember: 'Add member',
  teamRoleSearch: 'Search',
  teamRoleAdminTitle: 'Admin',
  teamRoleReaderTitle: 'Reader',
  teamRoleApproverTitle: 'Approver',
  teamRoleConfigureTitle: 'Configurer',
  teamRolePromoterTitle: 'Promoter',
  teamRoleAdminDescription:
    'The user can perform any action on the organization account, such as making payments, withdrawing funds to the configured bank account, as well as managing users and account settings.',
  teamRoleApproverDescription:
    'The user can approve payments configured by another team member. They can perform transfers without approval.',
  teamRoleConfigureDescription:
    'The user can configure transfers but cannot execute them. They need approval from the owner or any approver to do so.',
  teamRoleReaderDescription:
    'The user can view the information of the organization account, but cannot perform any action.',
  teamRolePromoterDescription:
    'The user can make payments to beneficiaries previously approved by the account owner.',
  teamTableName: 'Name',
  teamTableRole: 'Role',
  teamTableStatus: 'Status',
  teamTableActions: 'Actions',
  memberActive: 'Active',
  memberInactive: 'Inactive',
  memberOWNER: 'Owner',
  memberPAYMENT_APPROVER: 'Payment Approver',
  memberPAYMENT_ANALYST: 'Payment Configurer',
  memberREAD_ONLY: 'Read Only',
  memberPROMOTER: 'Promoter',
};

type LabelsLanguage = keyof typeof BASE_LABELS;

const TEAM_LABELS: Record<Language, Record<LabelsLanguage, string>> = {
  EN: BASE_LABELS,
  ES: {
    addMember: 'Añadir miembro',
    teamRoleSearch: 'Buscar',
    teamRoleAdminTitle: 'Administrador',
    teamRoleApproverTitle: 'Aprobador',
    teamRoleConfigureTitle: 'Configurador',
    teamRoleReaderTitle: 'Lector',
    teamRolePromoterTitle: 'Promotor',
    teamRoleAdminDescription:
      'Este rol puede realizar cualquier acción en la cuenta de la organización, como realizar pagos, retirar fondos a la cuenta bancaria configurada, así cómo la gestión de usuarios y la configuración de la cuenta.',
    teamRoleApproverDescription:
      'Este rol puede aprobar pagos configurados por otro miembro del equipo. Puede realizar transferencias sin aprobación.',
    teamRoleConfigureDescription:
      'Este rol puede configurar transferencias pero no puede ejecutarlas. Para eso necesita de la aprobación del propietario o cualquier aprobador.',
    teamRoleReaderDescription:
      'Este rol puede ver la información de la cuenta de la organización, pero no puede realizar ninguna acción.',
    teamRolePromoterDescription:
      'Este rol puede realizar pagos a los beneficiarios previamente aprobados por el propietario de la cuenta.',
    teamTableName: 'Nombre',
    teamTableRole: 'Rol',
    teamTableStatus: 'Estado',
    teamTableActions: 'Acciones',
    memberActive: 'Activo',
    memberInactive: 'Inactivo',
    memberOWNER: 'Propietario',
    memberPAYMENT_APPROVER: 'Aprobador de Pagos',
    memberPAYMENT_ANALYST: 'Configurador de Pagos',
    memberREAD_ONLY: 'Solo Lectura',
    memberPROMOTER: 'Promotor',
  },
};

export default TEAM_LABELS;
